var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"home-feature flex-1 flex text-center justify-center items-center p-10 bg-gray-200 bg-cover bg-center h-64",style:({ backgroundImage: 'url(' + _vm.image + ')' }),attrs:{"to":_vm.link}},[_c('h2',{staticClass:"text-white leading-none text-3xl"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }